import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(postObject: Request): Promise<Optional<string>> {
	const url = `${SERVICEBASEURL.BACKEND}/RecipeCategory`;
	return axios.post(url, postObject).toOptionalMapped((x) => x.data);
}

export interface Request {
	sortOrder: number;
	nameTranslations: {
		[key: string]: string;
	};
}

export interface Response {
	data: string;
}
